// extracted by css-extract-rspack-plugin
export default {"typeAreaTab":"Tab__typeAreaTab--mBqjp","typeTabActive":"Tab__typeTabActive--i42Sz Tab__typeAreaTab--mBqjp","typeTabDisabled":"Tab__typeTabDisabled--EYx4W Tab__typeAreaTab--mBqjp"};